'use strict';

var app = require('angular').module('graph.view', [require('angular-ui-bootstrap')]);

app.controller('dashboardGraphViewCtrl', ['graphDataFactory', 'myGraph', 'Form', 'Integration', '$uibModal', '$timeout', '$rootScope', 'siteConfig', require('./dashboardGraphViewCtrl')]);
app.config(['$stateProvider', require('./dashboardGraphViewConfig')]);
app.directive('graphSelectView', [require('./graphSelectViewDirective')]);
app.directive('graphDateView', [require('./graphDateViewDirective')]);
app.directive('graphMapView', [require('./graphMapViewDirective')]);